export default __webpack_public_path__ + "static/media/s4.9ed8f707.png";